import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

function CheckRegisterSelectedTag(props) {

    return (
        <div className="tag check-register-selected-tag">
            <span>{props.check.CheckNum}</span>
            <span>{props.check.CheckFrom}</span>
            <span className="tag-button cancel-button">
                <FontAwesomeIcon icon={faTimesCircle} onClick={() => props.cancel(props.check.PK_ID)} />
            </span>
        </div>
    );
}

export default CheckRegisterSelectedTag;